import { useState } from "react";
import { GoTriangleRight } from "react-icons/go";

type Props = {
    title: string,
    border: boolean,
    open?: boolean
    children: any
}

const AccordionComponent = ({ title, border, open, children }: Props) => {
    const [isOpen, setIsOpen] = useState(open ? open : false);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={`${border ? 'border-b' : ''}`}>
            <div
                className={`flex justify-between items-center py-4 px-4 cursor-pointer ${isOpen ? 'bg-gray-100 text-black' : 'text-gray-500'}`}
                onClick={toggleAccordion}
            >
                <span className="text-md font-medium flex items-center gap-1"><GoTriangleRight color="red" /> {title}</span>
                <svg
                    className={`w-6 h-6 transition-transform transform ${isOpen ? "rotate-180" : ""
                        }`}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M19 9l-7 7-7-7" />
                </svg>
            </div>
            {isOpen && (
                <div className="py-2 px-4 text-sm">
                    {children}
                </div>
            )}
        </div>
    );
};

export default AccordionComponent;
